export const storeToken = (data) => {
  // console.log("Called set");
  localStorage.setItem("user", JSON.stringify(data));
};
